<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <invoices-details-page />
    </div>
  </div>
</template>

<script>
import InvoicesDetailsPage from '../Components/InvoiceDetailsPage.vue';
export default {
  name: 'Invoices',
  components: {
    'invoices-details-page': InvoicesDetailsPage,
  },
};
</script>
<style scoped>
.content-section {
  padding-top: 80px;
}
</style>
